import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@app/directives/shared.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { c_card_stat_widget_component } from './c_card_stat_widget.component';
import { ChartModule } from '@app/components/chart/chart.module';
import { BaseChartDirective } from 'ng2-charts';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    MatSlideToggleModule,
    ChartModule,
    BaseChartDirective
  ],
  declarations: [ c_card_stat_widget_component],
  exports: [c_card_stat_widget_component],
})
export class c_card_stat_widget_module { }
